import state from './waitingRoomState'
import mutations from './waitingRoomMutations'
import getters from './waitingRoomGetters'
import actions from './waitingRoomActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
